<script>
import platformjs from '/vodalys/vlib/js/platform.min.js';

export default {
    methods: {
        check() {
            if (platformjs.os.family == 'Windows') {
                return ['Chrome', 'Firefox', 'Microsoft Edge'].filter(function (a) { return platformjs.name.indexOf(a) > -1; }).length > 0;
            }

            if (platformjs.os.family == 'OS X') {
                return ['Chrome', 'Safari'].filter(function (a) { return platformjs.name.indexOf(a) > -1; }).length > 0;
            }

            if (platformjs.os.family == 'iOS') {
                return ['Safari'].filter(function (a) { return platformjs.name.indexOf(a) > -1; }).length > 0;
            }

            if (platformjs.os.family == 'Android') {
                return ['Chrome'].filter(function (a) { return platformjs.name.indexOf(a) > -1; }).length > 0;
            }
        }
    },
    props: ["component"],
    translate25Context: 'troubleshooting',
    data() {
        return {
            platformjs: null,
            checkPlatform: 'pending',
        }
    },
    async mounted() {
        ;
        this.platformjs = platformjs;
        this.checkPlatform = await this.check() ? 'ok' : 'ko'
    }
};
</script>

<template>
    <div class="troubleshooting-http-status">
        <troubleshooting-page-status :status="checkPlatform">
            <template #content>{{ platformjs ? platformjs.description : '' }}</template></troubleshooting-page-status>

        <f-hint v-if="checkPlatform == 'ko' && platformjs.os.family == 'Windows'" type="negative"
            icon="fa6-triangle-exclamation">
            <template #message>
                <div>{{ $vt("Vodalys Studio player is optimized on Windows for either: ") }}</div>
                <div>
                    <ul>
                        <li>
                            <a target="_blank" href="https://www.google.com/chrome/">Google Chrome</a>
                        </li>
                        <li>
                            <a target="_blank" href="https://www.mozilla.org/fr/firefox/new/">Mozilla Firefox</a>
                        </li>
                        <li>
                            <a target="_blank" href="https://www.microsoft.com/fr-fr/edge/download">Microsoft Edge</a>
                        </li>
                    </ul>
                </div>
            </template>
        </f-hint>

        <f-hint v-if="checkPlatform == 'ko' && platformjs.os.family == 'OS X'" type="negative"
            icon="fa6-triangle-exclamation">
            <template #message>
                <div>{{ $vt("Vodalys Studio player is optimized on OS X for either: ") }}</div>
                <div>
                    <ul>
                        <li>
                            <a target="_blank" href="https://www.google.com/chrome/">Google Chrome</a>
                        </li>
                        <li>
                            <a target="_blank" href="https://www.apple.com/fr/safari/">Safari</a>
                        </li>
                    </ul>
                </div>
            </template>
        </f-hint>

        <f-hint v-if="checkPlatform == 'ko' && platformjs.os.family == 'iOS'" type="negative"
            icon="fa6-triangle-exclamation">
            <template #message>
                <div>{{ $vt("Vodalys Studio player is optimized on iOS for ") }} <a target="_blank"
                        href="https://www.apple.com/fr/safari/">Safari</a></div>
            </template>
        </f-hint>

        <f-hint v-if="checkPlatform == 'ko' && platformjs.os.family == 'Android'" type="negative"
            icon="fa6-triangle-exclamation">
            <template #message>
                <div>{{ $vt("Vodalys Studio player is optimized on Android for ") }}<a target="_blank"
                        href="https://www.google.com/chrome/">Google Chrome</a></div>
            </template>
        </f-hint>

    </div>
</template>

<style lang="scss">
.troubleshooting-http-status {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
</style>